import { render, staticRenderFns } from "./xskSkuM.vue?vue&type=template&id=2e8208e3&scoped=true"
import script from "./xskSkuM.vue?vue&type=script&lang=js"
export * from "./xskSkuM.vue?vue&type=script&lang=js"
import style0 from "./xskSkuM.vue?vue&type=style&index=0&id=2e8208e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8208e3",
  null
  
)

export default component.exports